import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../components/button.jsx";
import get from "../functions/get.js";
import CreateExercise from "./create_exercise.jsx";
import Loading from "../components/loading.jsx";
import { ListLoader } from "../components/list_loader.jsx";

const Exercises = () => {

    const location = useLocation();

    const [ exercises, setExercises ] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const onRes = (res, data) => {

        setLoading(false);
        setExercises(data);

    };

    useEffect(() => {

        if (location.pathname === "/admin/uebungen") {
            setLoading(true);
            get("/admin/exercises", onRes, onRes);
        };
        
    }, [location.pathname]);


    return (
        <div>
            {!location.pathname.includes("/erstellen") &&
                <>
                    <h2>ÜBUNGEN BEARBEITEN</h2>

                    <ListLoader url="/admin/exercises" buttonText="Neue Übung" buttonRedirect="erstellen" redirect = "erstellen/uebung" />

                </>
            }

            {location.pathname.includes("/erstellen") &&
                <CreateExercise />
            }
        </div>
    );

}; export default Exercises;